import ellipsize from "ellipsize";
import { CheveronDownIcon, DownloadIcon } from "assets/icons/HeroIcons";
import { getFileExtension } from "utils/IdentifyFileType";
import { DocumentIcon } from "assets/icons/FilesIcons/DocumentIcon";
import { ImageIcon } from "assets/icons/FilesIcons/ImageIcon";
import { AudioIcon } from "assets/icons/FilesIcons/AudioIcon";
import { VideoIcon } from "assets/icons/FilesIcons/VideoIcon";

const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
const audioExtensions = ['mp3', 'wav', 'm4a', 'aac'];
const videoExtensions = ['mp4', 'mov', 'avi', 'webm'];
const documentExtensions = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv', 'txt'];
const fileIcons: {[key: string]: any} = {
    image: <ImageIcon />,
    audio: <AudioIcon />,
    video: <VideoIcon />,
    document: <DocumentIcon />,
};
const getFileCategory = (ext: string) => {
    if (imageExtensions.includes(ext)) return 'image';
    if (audioExtensions.includes(ext)) return 'audio';
    if (videoExtensions.includes(ext)) return 'video';
    if (documentExtensions.includes(ext)) return 'document';
    return '';
};

interface QueryItem {
    file: {
        id: number;
        path?: string;
        link?: string;
        title?: string;
    };
    text: string;
    fileType?: string;
}
interface QueryResponseProps {
    item: QueryItem;
}

export const QueryResponse = ({ item }: QueryResponseProps) => {
    const id = item?.file?.id || "";
    const filePath = item?.file?.path || "";
    const fileName = item?.file?.title || filePath.split("/").pop() || "file";
    const extension = getFileExtension(filePath).replace(/^\./, "").toLowerCase().split("?")[0];

    return (
        <li key={id}>
            <label className="flex items-center mb-3">
                Response{" "}
                <CheveronDownIcon className={"h-3 w-3 mt-1 ms-1"} />
            </label>
            <p className="ps-3 border-l-2 border-l-primaryLight text-textMid text-[15px] dark:text-caption ">
                <span>{item.text}</span>
            </p>
            {item?.file?.link && (
                <a
                    href={item?.file?.link}
                    target="_blank"
                    className="block mt-6 text-primary hover:text-primaryMid dark:text-textMain"
                >
                    {fileName}
                </a>
            )}
            {filePath && !item?.file?.link && (
                <div className="grid grid-cols-12 gap-4 items-end justify-between mt-6 bg-primaryLight rounded-md p-4 max-w-48">
                    <span className="col-span-12">{fileIcons[getFileCategory(extension)]}</span>
                    <span className="col-span-8 text-textMid text-sm dark:text-caption capitalize">
                        {ellipsize(`${fileName}`, 20)}
                    </span>
                    <a
                        href={filePath}
                        download={fileName}
                        className="col-span-4 ms-auto pr-3"
                        target="_blank"
                    >
                        <DownloadIcon className="h-5 w-5 fill-textMid" />
                    </a>
                </div>
            )}
        </li>
    );
};
